import React, { Component } from "react";
import App_data from "../../config/App_data";
import FD from "../../RestAPI/fetchData";
import language from "../../../assets/languages/language";
class Unsubscribe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      send_notification: "",
      message_background: "bg-danger",
      displaytext: "hide_block",
      isSend: false,
    };
    this.settingChanged = this.settingChanged.bind(this);
  }

  componentDidMount() {
    let parsed = this.props.location.query;
    if (parsed.email) {
      this.setState({
        email: parsed.email,
      });
    }
  }
  static contextTypes = {
    router: React.PropTypes.object,
  };
  settingChanged() {
    if (document.getElementById("verification").value === "") {
      this.setState({ displaytext: "show_block" });
      this.setState({ message: "This field is required" });
      return;
    } else {
      if (document.getElementById("verification").value === "false") {
        this.context.router.push("/");
        return;
      }
      const data = {
        email: this.state.email,
        send_notification: false,
      };
      FD.callAPI(App_data.backend_api + "/user/updateUnsubscribe", data).then(
        (resp) => {
          if (resp.success) {
            this.setState({
              isSend: true,
            });
          } else {
            console.log("fails");
          }
        }
      );
    }
  }

  render() {
    const { isSend } = this.state;

    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper">
            <img
              src={App_data.frontend_url + "/img/logo1.png"}
              alt=""
              width="200"
            />
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
            <div className="card-group mb-0">
              <div className="card p-2  ">
                {!isSend ? (
                  <div className="card-block">
                    <h4>Unsubscribe</h4>
                    <h6 className=" text-center">Are you sure?</h6>
                    <p className="" style={{ color: "rgb(42, 59, 78)" }}>
                      Do you want to unsubscribe from email notifications.
                    </p>

                    <div className="input-group mb-1">
                      <span className="input-group-addon-social-registration">
                        <i className="fa fa-cog" />
                      </span>
                      <select className="form-control" id="verification">
                        <option value="">Select setting</option>
                        <option value={true}>{language.LC().YES}</option>
                        <option value={false}> {language.LC().NO}</option>
                      </select>
                    </div>
                    <p
                      className={this.state.displaytext}
                      style={{
                        color: "#f86c6b",
                      }}
                    >
                      {this.state.message}*
                    </p>
                    <div className="row">
                      <div className="col-md-12">
                        <button
                          type="button"
                          style={{ width: 100 + "%" }}
                          className="btn btn-primary"
                          onClick={this.settingChanged}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="card-block">
                    {" "}
                    <img
                      src={App_data.frontend_url + "/img/success-ic.svg"}
                      className="margin_bottom_30  unsubscribe-image"
                      alt=""
                    />
                    <h6 className=" text-center"> Successfully Unsubscribed</h6>
                    <p className="" style={{ color: "rgb(42, 59, 78)" }}>
                      You successfully unsubscribed from the email notifications
                      and should not receive future app email notifications.
                    </p>
                    <p className="" style={{ color: "rgb(42, 59, 78)" }}>
                      If you interested to receive this in the future then
                      navigate into the profile section and activate the email
                      notifications.
                    </p>
                    <div className="row">
                      <div className="col-md-12">
                        <button
                          type="button"
                          style={{ width: 100 + "%" }}
                          className="btn btn-primary"
                          onClick={() => this.context.router.push("/")}
                        >
                          Go to App
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Unsubscribe;



// WEBPACK FOOTER //
// ./src/views/Pages/Unsubscribe/Unsubscribe.js